export default "__VITE_ASSET__Cyz3_tvR__"